import type { Filter as PillFilter, FilterDataRadio } from '@/app/common/filters/core/filtersTypes';

export const FilterRadioPill = (filter: PillFilter): string[] => {
  const data = filter.data as FilterDataRadio;
  const selected = data.options.find((o) => o.selected);
  // Use data.label if present, otherwise fallback to empty string
  return selected ? [selected.label] : [data.label ?? ''];
};
